import React, { Component } from "react";
import Chart, { seriesName, selectColor, approximationMax } from "./Chart.js";

export default class EtAccumulationChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      failed: false,
      noData: false,

      dailyData: null,
      
      options: {
        title: {
          text: "Weekly ET Accumulation"
        },
        yAxis: [
          {
            title: {
              text: "ET"
            },
            lineWidth: 1,
            gridLineWidth: 0,
            tickWidth: 1,
            tickLength: 5,
            opposite: false,
            min: 0
          }
        ]
      }
    };
  }

  componentDidMount() {
    this.loadChart();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.startDate !== this.props.startDate ||
      prevProps.stopDate !== this.props.stopDate ||
      prevProps.stationId !== this.props.stationId ||
      prevProps.seasonStart !== this.props.seasonStart ||
      prevProps.seasonStop !== this.props.seasonStop ||
      prevProps.dailyData !== this.props.dailyData
    ) {
      this.loadChart();
    }
  }

  loadChart() {
    if (this.props.loadingData) {
      this.setState({ loading: true, noData: false, failed: false });
      return;
    }

    if (!this.props.dailyData) {
      this.setState({ loading: false, failed: true });
      return;
    }

    this.setState({ loading: true, noData: false, failed: false }, () => {
      const dailyData = {};

      Object.keys(this.props.dailyData).forEach(year => {
        const yearData = this.props.dailyData[year];
        if (yearData && yearData.ETDATA) {
          const etValues = yearData.ETDATA;
          const accumulated = [];
          let runningTotal = 0;

          etValues.forEach(value => {
            if (typeof value === 'number') {
              runningTotal += value;
              accumulated.push({
                accumulation: runningTotal,
                status: 'valid'
              });
            } else {
              accumulated.push({
                accumulation: runningTotal,
                status: 'missing'
              });
            }
          });

          dailyData[year] = {
            data: {
              ET: {
                M: accumulated
              }
            }
          };
        }
      });

      if (Object.keys(dailyData).length > 0) {
        this.setState({ dailyData: dailyData }, () => {
          this.initializeChart();
        });
      } else {
        this.setState({ loading: false, failed: true });
      }
    });
  }

  initializeChart() {
    if (!this.state.dailyData) return false;
    let noData = true;

    this.setState({
      options: {
        ...this.state.options,
        series: [
          ...Object.keys(this.state.dailyData).map(year => {
            return {
              name: seriesName(year),
              type: "line",
              data: this.state.dailyData[year]
                ? this.state.dailyData[year].data.ET.M.map(data => {
                    if (data.status !== "missing") noData = false;
                    return data.accumulation;
                  })
                : [],
              dataGrouping: {
                approximation: approximationMax
              },
              color: selectColor(
                year,
                this.props.seasonStart,
                this.props.graphOptions
              ),
              lineWidth:
                parseInt(year) === this.props.seasonStart.year() ? 5 : 2,
              pointStart: new Date(this.props.seasonStart).getTime()
            };
          })
        ]
      },
      loading: false,
      noData: noData,
      failed: false
    });
  }

  render() {
    return (
      <Chart
        options={this.state.options}
        loading={this.state.loading}
        failed={this.state.failed}
        noData={this.state.noData}
      />
    );
  }
}